import { Link } from 'react-router-dom'
import { client } from '../../hooks/Client'
import useSharedCollection from '../../firebase/useSharedCollection'
import useSettings from '../../hooks/Settings.jsx'
import usePersonaTerms from '../../hooks/usePersonaTerms'
import { filterStarred } from '../../helpers/starred/starred'
import StaticCardLabel from './StaticCardLabel'

/**
 * Dashboardkaart 'Met ster': de huishoudens en deelnemers met een ster bij
 * elkaar, met een link naar hun pagina (verzoek BuurtKlusBedrijf 2026-10-06:
 * 'een kaart met de gemarkeerde items bij elkaar').
 *
 * Een module die uitstaat telt niet mee — niet voor 'laden' en niet voor
 * 'niets', anders wacht de kaart op een lijst die nooit komt. Drie toestanden
 * op volgorde van zekerheid: eerst 'weet ik niet', dan 'niets', dan de lijst.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 *
 * @returns {JSX.Element}
 */
const DashboardStarredCard = () => {
    const { housevisits, personasOn } = useSettings()
    const personaTerms = usePersonaTerms()
    const metHuishoudens = housevisits === true
    const metDeelnemers = personasOn === 'flex'
    // Alleen de collecties van modules die aanstaan: een organisatie zonder
    // Deelnemers betaalt anders een Personas-listener voor een lege helft.
    const adresses = useSharedCollection(metHuishoudens ? 'Adresses' : null)
    const personas = useSharedCollection(metDeelnemers ? 'Personas' : null)
    const loaded = (!metHuishoudens || Array.isArray(adresses)) && (!metDeelnemers || Array.isArray(personas))

    if (!loaded) {
        return (
            <div>
                <StaticCardLabel title='Met ster' />
                <p className='score-explain-card__placeholder'>Laden…</p>
            </div>
        )
    }

    const huishoudens = metHuishoudens ? filterStarred(adresses) : []
    const deelnemers = metDeelnemers ? filterStarred(personas) : []

    if (huishoudens.length === 0 && deelnemers.length === 0) {
        return (
            <div>
                <StaticCardLabel title='Met ster' />
                <p className='score-explain-card__placeholder'>Nog niets met een ster.</p>
            </div>
        )
    }

    return (
        <div>
            <StaticCardLabel title='Met ster' />
            <div className='starred-card__groups'>
                {huishoudens.length > 0 && (
                    <section className='starred-card__group'>
                        <h4 className='starred-card__heading'>Huishoudens</h4>
                        <ul className='starred-card__list'>
                            {huishoudens.map((h) => (
                                <li key={h.ID}>
                                    <Link to={`/${client}/adressdetails/${h.ID}`}>{h.Title || 'Naamloos huishouden'}</Link>
                                </li>
                            ))}
                        </ul>
                    </section>
                )}
                {deelnemers.length > 0 && (
                    <section className='starred-card__group'>
                        <h4 className='starred-card__heading'>{personaTerms.plural}</h4>
                        <ul className='starred-card__list'>
                            {deelnemers.map((p) => (
                                <li key={p.ID}>
                                    <Link to={`/${client}/personabuilder/${p.ID}`}>{p.Name || `Naamloze ${personaTerms.singular.toLowerCase()}`}</Link>
                                </li>
                            ))}
                        </ul>
                    </section>
                )}
            </div>
        </div>
    )
}

export default DashboardStarredCard
